// 首页
<template>
  <div class="home">
    <van-nav-bar fixed placeholder safe-area-inset-top>
      <template #title>
        <div class="flex justify-center align-end" style="font-size: 16px">
          <van-icon
            style="margin-right: 8px"
            size="24"
            :name="require('@/assets/images/login-page/logo.png')"
          />
          {{ $t("menu.home") }}
        </div>
      </template>
      <template #right>
        <div>
          <van-icon
            style="margin-right: 8px"
            size="24"
            :name="require('@/assets/images/icon/add.png')"
            @click="add"
          />
        </div>
      </template>
    </van-nav-bar>
    <section class="container">
      <template v-if="token">
        <van-pull-refresh v-model="refreshing" @refresh="handlePullDown">
          <!-- <template #pulling="props">
            <div class="pull">
              <van-icon
                style="margin-right: 14px"
                size="10"
                :name="require('@/assets/images/icon/pull.png')"
              />Pull to connect
            </div>
          </template>
          <template #loosing>
            <div class="pull">
              <van-icon
                style="margin-right: 14px"
                size="10"
                :name="require('@/assets/images/icon/pull.png')"
              />Pull to connect
            </div>
          </template> -->
          <!-- 2.1 在有设备连接后，有下拉连接提示，并持续出现 -->
          <div v-if="list.length && idOfConnectedDevice === -1" class="pull">
            <van-icon
              style="margin-right: 14px"
              size="10"
              :name="require('@/assets/images/icon/pull.png')"
            />Pull to connect
          </div>
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            :finished-text="$t('tips.noMore')"
            :offset="100"
            @load="onLoad"
          >
            <div class="van-clearfix" v-if="list.length">
              <div class="card" v-for="item in list" :key="item.id">
                <van-swipe-cell>
                  <div
                    class="card-item flex justify-between"
                    @click="linkToDetail(item)"
                  >
                    <div class="left">
                      <div
                        class="connect flex align-center"
                        @click.prevent.stop="changeConnectionStatus(item)"
                        :style="{
                          color:
                            idOfConnectedDevice === item.id
                              ? '#3EE192'
                              : '#8F8F8F',
                        }"
                      >
                        <van-icon
                          style="margin-right: 8px"
                          size="22"
                          :name="
                            idOfConnectedDevice === item.id
                              ? require('@/assets/images/icon/on.png')
                              : require('@/assets/images/icon/off.png')
                          "
                        />
                        <!-- <i
                          class="connect-point"
                          :style="{
                            background:
                              idOfConnectedDevice === item.id
                                ? '#00FF06'
                                : '#CECECE',
                          }"
                        ></i> -->
                        {{
                          idOfConnectedDevice === item.id
                            ? "connect"
                            : "disconnect"
                        }}
                      </div>
                      <div class="title">{{ item.nameEn }}</div>
                      <!-- <div class="desc">
                        {{ item.tasteNameEn }}
                        <span style="margin-left: 2px">{{
                          item.percentageNicotineInhalation
                        }}</span>
                      </div> -->
                      <div
                        v-if="item.productType === 1"
                        class="step-container flex align-center"
                      >
                        <van-icon
                          style="margin-right: 4px"
                          size="14"
                          :name="require('@/assets/images/icon/oil.png')"
                        />
                        <div class="step-bg">
                          <span
                            :style="{ width: `${item.surplusTimes * 100}%` }"
                          ></span>
                        </div>
                      </div>
                      <div
                        v-if="item.productType === 2 && idOfConnectedDevice !== item.id"
                        class="flex align-center"
                      >
                        <van-icon
                          size="22"
                          :name="
                            require('@/assets/images/icon/power_empty.png')
                          "
                        />
                      </div>
                      <div
                        v-if="item.productType === 2 && idOfConnectedDevice === item.id"
                        class="flex align-center"
                      >
                        <van-icon v-if="battery_CurDevice === -1" size="22" :name="require('@/assets/images/icon/power_empty.png')" />
                        <van-icon v-if="battery_CurDevice === 0" size="22" :name="require('@/assets/images/icon/batteryActivity_Low.png')" />
                        <van-icon v-if="battery_CurDevice === 1" size="22" :name="require('@/assets/images/icon/batteryActivity_Medium.png')" />
                        <van-icon v-if="battery_CurDevice === 2" size="22" :name="require('@/assets/images/icon/batteryActivity_High.png')" />
                      </div>
                    </div>
                    <div class="right flex justify-between">
                      <div class="flex align-center">
                        <img :src="item.picture" />
                      </div>
                      <van-icon
                        size="22"
                        name="like"
                        :color="item.isLike ? '#FF6363' : '#CECECE'"
                        @click.prevent.stop="editLike(item)"
                      />
                    </div>
                  </div>
                  <template #right>
                    <div class="swipe flex-column justify-between">
                      <div
                        class="capsule flex align-center"
                        style="color: #34e0ae"
                        @click.prevent.stop="stick(item)"
                      >
                        <van-icon
                          size="25"
                          :name="require('@/assets/images/icon/top.png')"
                        />Sticky on Top
                      </div>
                      <div
                        class="capsule flex align-center"
                        style="color: #c30d23"
                        @click.prevent.stop="remove(item)"
                      >
                        <van-icon
                          size="25"
                          :name="require('@/assets/images/icon/unpair.png')"
                        />Unpair
                      </div>
                      <div
                        class="capsule flex align-center"
                        style="color: #8f8f8f"
                        @click.prevent.stop="hide(item)"
                      >
                        <van-icon
                          size="25"
                          :name="require('@/assets/images/icon/remove.png')"
                        />Remove List
                      </div>
                    </div>
                  </template>
                </van-swipe-cell>
              </div>
            </div>
            <div v-else>
              <van-empty>
                <view slot="image"></view>
                <span
                  class="flex-column justify-center align-center"
                  style="line-height: 2"
                  slot="description"
                >
                  <span class="flex align-center"
                    >Please click
                    <van-icon name="add-o" size="24" style="margin: 0 8px" /> in
                    the upper right,</span
                  >
                  to add a new device.
                </span>
              </van-empty>
            </div>
          </van-list>
        </van-pull-refresh>
      </template>
      <template v-else>
        <div class="card">
          <div class="card-item login-content">
            <div>Create an account or log in to get the full experience!</div>
            <div class="flex justify-center">
              <div class="btn1" @click="$router.push('welcome')">
                {{ $t("register.register") }}
              </div>
              <div class="btn2" @click="$router.push('login')">
                {{ $t("register.login") }}
              </div>
            </div>
          </div>
        </div>
        <van-empty>
          <view slot="image"></view>
          <span
            class="flex-column justify-center align-center"
            style="line-height: 2"
            slot="description"
          >
            <span class="flex align-center"
              >Please click
              <van-icon name="add-o" size="24" style="margin: 0 8px" /> in the
              upper right,</span
            >
            to add a new device.
          </span>
        </van-empty>
      </template>
    </section>
    <details-dialog
      v-model="showDetail"
      :changeConnectionStatus="changeConnectionStatus"
      :detail_Props="detail"
      :editLike="editLike"
      :linkToDetail="linkToDetail"
      :idOfConnectedDevice="idOfConnectedDevice"
    />
    <tab-bar />
  </div>
</template>

<script>
import {
  getCurrentEuipmentListWithTotal,
  editEquipmentLike,
  hideEuipment,
  removeEuipment,
  getEuipmentDetail,
  setStickEuipment,
  getCurrentAllList,
} from "@/api";
import TabBar from "@/components/tab-bar";
import DetailsDialog from "./modules/DetailsDialog";
export default {
  name: "Home",
  components: {
    TabBar,
    DetailsDialog,
  },
  data() {
    return {
      showDetail: false,
      loading: false,
      finished: false,
      refreshing: false,
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
      list: [],
      detail: {},
      timer4GetDeviceList: null,
      wait4What: null, // 为何事等待
      data4Wait: null, // 等待的所需的数据

      battery_CurDevice: -1, // 当前设备电量
    };
  },
  computed: {
    firstTimeGetIntoDeviceListPage() {
      return this.$store.state.app.firstTimeGetIntoDeviceListPage;
    },
    dataOfDeviceListPage() {
      return this.$store.state.app.dataOfDeviceListPage;
    },
    idOfConnectedDevice() {
      return this.$store.state.app.idOfConnectedDevice;
    },
    theLatestBattery() {
      return this.$store.state.app.theLatestBattery;
    },
    token() {
      return this.$store.state.user.token;
    },
  },
  watch: {
    showDetail: function(val, oldVal) {
      if (!val) {
        this.setCallback_ForCurPage();
        this.updateBattery();
      }
    },
    theLatestBattery: function(val, oldVal) {
      this.updateBattery();
    },
  },
  mounted() {
    this.setCallback_ForCurPage();
    this.updateBattery();
    if (this.token) {
      if (this.firstTimeGetIntoDeviceListPage) {
        this.$store.commit("setFirstTimeGetIntoDeviceListPage", false);
        this.init();
      } else {
        this.list = this.dataOfDeviceListPage;
        this.$toast.clear();
      }
    }
  },
  beforeDestroy() {
    window.disconnectDevice_Succeed = (ignore) => this.$store.commit("setIdOfConnectedDevice", -1); // 注册 断开设备成功回调(宿主是调用方)
    this.$store.commit("setDataOfDeviceListPage", this.list);
  },
  methods: {
    /** 设置回调函数 */
    setCallback_ForCurPage() {
      window.addDevice_Succeed = this.addDevice_Succeed_Callback; // 注册 添加设备成功后的回调函数(设备连接成功也用这个接口)
      window.addDevice_Failed = this.addDevice_Failed_Callback; // 注册 添加设备失败后的回调函数(设备连接失败也用这个接口)
      window.connectDevice_Succeed = this.connectDevice_Succeed_Callback; // 注册 设备连接成功后的回调函数
      window.connectDevice_Failed = this.connectDevice_Failed_Callback; // 注册 设备连接失败后的回调函数
      window.disconnectDevice_Succeed = this.disconnectDevice_Succeed_Callback; // 注册 断开设备连接成功后的回调函数
      window.disconnectDevice_Failed = this.disconnectDevice_Failed_Callback; // 注册 断开设备连接失败后的回调函数
      window.removeDevice_Succeed = this.removeDevice_Succeed_Callback; // 注册 断开设备连接成功后的回调函数
      window.removeDevice_Failed = this.removeDevice_Failed_Callback; // 注册 断开设备连接失败后的回调函数
      window.connecting2AnyDeviceInTheList_Succeed = this.connecting2AnyDeviceInTheList_Succeed_Callback; // 注册 连接列表中任意一个设备 成功后的回调函数
      window.connecting2AnyDeviceInTheList_Failed = this.connecting2AnyDeviceInTheList_Failed_Callback; // 注册 连接列表中任意一个设备 失败后的回调函数
    },

    // 初始化列表
    async init() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      const onRefresh = this.pagination.page === 1;
      await getCurrentEuipmentListWithTotal({
        pageNum: this.pagination.page,
        pageSize: this.pagination.size,
      })
        .then((res) => {
          if (res.code === 200) {
            if (onRefresh) this.list = [];
            if (res.data.total !== undefined && res.data.total !== null) {
              this.pagination.total = res.data.total;
              this.finished = this.list.length >= this.pagination.total;
            }
            if (res.data.productEquipmentInfoVos.length > 0) {
              this.list = [...this.list, ...res.data.productEquipmentInfoVos];
              this.pagination.page += 1;
            }
          }
        })
        .finally(() => {
          if (this.timer4GetDeviceList) clearTimeout(this.timer4GetDeviceList);
          this.timer4GetDeviceList = null;
          this.loading = false;
          this.$toast.clear();
        });
    },

    /** 获取 当前用户使用中(包括隐藏)的设备 列表 */
    getUsingEuipments_WithHide(
      callbackWhenSuccess, // 成功时回调
      callbackWhenFail // 失败时回调
    ) {
      getCurrentAllList({
        pageNum: 1,
        pageSize: 50000,
      }).then((res) => {
        if (res.code === 200) {
          if (callbackWhenSuccess) callbackWhenSuccess(res.data);
        } else {
          this.$toast("Network anomaly, Operation interrupted.");
          if (callbackWhenFail) callbackWhenFail(res);
        }
      });
    },

    // 底部加载
    onLoad() {
      if (this.list.length < this.pagination.total) {
        if (this.timer4GetDeviceList) {
          clearTimeout(this.timer4GetDeviceList);
          this.timer4GetDeviceList = null;
        }
        this.timer4GetDeviceList = setTimeout(() => this.init(), 500);
      } else {
        this.loading = false;
      }
    },
    /** 下拉操作 */
    handlePullDown() {
      if (this.idOfConnectedDevice === -1) {
        // 当前无设备连接着

        this.tryConnecting2AnyDeviceInTheList();
      } else {
        // 当前有设备连接着

        this.onRefresh();
      }
      this.refreshing = false;
    },
    // 下拉(重置列表,回到第一页的数据)
    onRefresh() {
      this.pagination.page = 1;
      if (this.timer4GetDeviceList) {
        clearTimeout(this.timer4GetDeviceList);
        this.timer4GetDeviceList = null;
      }
      this.timer4GetDeviceList = setTimeout(() => this.init(), 500);
    },
    /** 下拉·连接列表中任意一个设备 */
    tryConnecting2AnyDeviceInTheList() {
      this.getUsingEuipments_WithHide((euipmentArr) => {
        if (!euipmentArr.length) return;
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          className: "tips_toast",
          position: "middle",
          type: "html",
          message: `<div class="van-loading van-loading--circular van-toast__loading"><span class="van-loading__spinner van-loading__spinner--circular"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div><p>Connecting...</p>Tips:Please vape your device to wake Bluetooth.`,
        });
        /** 通知宿主连接列表中任意一个设备 */
        window.webkit.messageHandlers.tryConnecting2AnyDeviceInTheList.postMessage(
          JSON.stringify(euipmentArr)
        );
      }, null);
    },
    // 编辑喜欢/不喜欢
    editLike(item, thenDo) {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      const like = item.isLike ? 0 : 1;
      editEquipmentLike({
        id: item.id,
        isLike: like,
      }).then((res) => {
        this.$toast(res.msg);
        const i = this.list.findIndex((e) => e.id === item.id);
        this.list[i].isLike = like;
        this.$toast.clear();
        if (thenDo) thenDo();
      });
    },
    // 跳转详情
    linkToDetail(item, thenDo) {
      if (!item || !item.id) {
        console.error('获取设备详情时item:');
        console.log(item);
        return;
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      this.detail = {};
      getEuipmentDetail({
        id: item.id,
      }).then((res) => {
        this.$toast.clear();
        this.detail = res.data;
        this.showDetail = true;
        if (thenDo) thenDo(res);
      });
    },
    /** 更改连接状态 */
    changeConnectionStatus(item) {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        className: "tips_toast",
        position: "middle",
        type: "html",
        message: `<div class="van-loading van-loading--circular van-toast__loading"><span class="van-loading__spinner van-loading__spinner--circular"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div><p>Connecting...</p>Tips:Please vape your device to wake Bluetooth.`,
      });
      if (this.idOfConnectedDevice === item.id) {
        window.webkit.messageHandlers.try2DisconnectDevice.postMessage(
          JSON.stringify(item)
        ); // 通知宿主断开设备
      } else {
        window.webkit.messageHandlers.try2ConnectDevice.postMessage(
          JSON.stringify(item)
        ); // 通知宿主连接设备
      }
    },
    // 置顶设备
    stick(item) {
      setStickEuipment({
        id: item.id,
        imie: this.$store.state.app.imie,
      }).then((res) => {
        this.$toast(res.msg);
        this.onRefresh();
      });
    },
    // 移除设备
    remove(item) {
      if (this.idOfConnectedDevice === item.id) {
        this.$dialog
          .alert({
            title: "Tips",
            message: "Do you want to unpair this device?",
            showCancelButton: true,
            confirmButtonText: "Unpair",
            confirmButtonColor: "#1989fa",
            cancelButtonColor: "#1989fa",
          })
          .then(() => {
            this.$toast.loading({
              duration: 0,
              forbidClick: true,
            });
            window.webkit.messageHandlers.try2RemoveDevice.postMessage(
              item.equipmentName
            );
          });
      } else {
        this.$toast("Please connect the device!");
      }
    },
    // 隐藏设备(不在设备列表中出现，可以在历史列表中恢复)
    hide(item) {
      this.$dialog
        .alert({
          title: "Tips",
          message: "Do you want to remove this device from list?",
          showCancelButton: true,
          confirmButtonText: "Remove",
          confirmButtonColor: "#1989fa",
          cancelButtonColor: "#1989fa",
        })
        .then(() => {
          this.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          if (this.idOfConnectedDevice === -1) {
            this.request4Hide(item);
          } else {
            this.data4Wait = item;
            this.wait4What = "disconnect4Hide";
            window.webkit.messageHandlers.try2DisconnectDevice.postMessage(
              JSON.stringify(item)
            ); // 通知宿主断开设备
          }
        });
    },
    /** 隐藏请求 */
    request4Hide(item) {
      hideEuipment({ id: item.id, isRemove: 1 }).then((res) => {
        this.wait4What = null;
        this.$toast(res.msg);
        this.onRefresh();
      });
    },
    // 添加设备
    add() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        className: "tips_toast",
        position: "middle",
        type: "html",
        message: `<div class="van-loading van-loading--circular van-toast__loading"><span class="van-loading__spinner van-loading__spinner--circular"><svg viewBox="25 25 50 50" class="van-loading__circular"><circle cx="50" cy="50" r="20" fill="none"></circle></svg></span></div><p>Searching...</p>Tips:Please vape your device to wake Bluetooth.`,
      });
      this.getUsingEuipments_WithHide((euipmentArr) => {
        window.webkit.messageHandlers.whenAddedDevicesReceived.postMessage(
          // 将已添加过的设备列表推送给宿主
          JSON.stringify(euipmentArr)
        );
      }, null);
    },
    /** 添加设备成功回调(宿主是调用方) */
    addDevice_Succeed_Callback(id) {
      this.$toast.clear();
      this.$store.commit("setIdOfConnectedDevice", parseInt(id));
      this.stick({ id: id });
      this.$toast("operate successful");
    },
    /** 添加设备失败回调(宿主是调用方) */
    addDevice_Failed_Callback(id) {
      this.$toast.clear();
      this.$toast("time out");
    },
    /** 设备连接成功回调(宿主是调用方) */
    connectDevice_Succeed_Callback(equipmentCode) {
      this.getUsingEuipments_WithHide((euipmentArr) => {
        const id = this.getIdByFeatures(
          euipmentArr,
          {
            equipmentId: equipmentCode,
          },
          "为《设备连接成功》置顶对应设备"
        );
        if (id === -1) return;
        this.$store.commit("setIdOfConnectedDevice", id);
        this.stick({ id: id });
        this.$toast("connect successfully");
      }, null);
    },
    /** 设备连接失败回调(宿主是调用方) */
    connectDevice_Failed_Callback(equipmentCode) {
      this.$toast.clear();
      this.$toast("connect fail");
    },
    /** 断开设备成功回调(宿主是调用方) */
    disconnectDevice_Succeed_Callback(equipmentCode) {
      if (this.wait4What) {
        switch (this.wait4What) {
          case "disconnect4Hide":
            this.$store.commit("setIdOfConnectedDevice", -1);
            const data = JSON.parse(JSON.stringify(this.data4Wait));
            this.data4Wait = null;
            this.request4Hide(data);
            break;
        }
      } else {
        this.$toast.clear();
        this.$store.commit("setIdOfConnectedDevice", -1);
        this.$toast("disconnect successful");
      }
    },
    /** 断开设备失败回调(宿主是调用方) */
    disconnectDevice_Failed_Callback(equipmentCode) {
      if (this.wait4What) {
        switch (this.wait4What) {
          case "disconnect4Hide":
            this.data4Wait = null;
            this.wait4What = null;
            this.$toast("operate fail");
            break;
        }
      } else {
        this.$toast.clear();
        this.$toast("disconnect fail");
      }
    },
    /** 移除设备成功回调(宿主是调用方) */
    removeDevice_Succeed_Callback(equipmentCode) {
      this.$store.commit("setIdOfConnectedDevice", -1);
      const id = this.getIdByFeatures(
        this.list,
        {
          equipmentId: equipmentCode,
        },
        "注销设备"
      );
      if (id === -1) return;
      removeEuipment({ id: id }).then((res) => {
        this.$toast("delete successful");
        this.onRefresh();
      });
    },
    /** 移除设备失败回调(宿主是调用方) */
    removeDevice_Failed_Callback(equipmentCode) {
      this.$toast.clear();
      this.$toast("delete fail");
    },
    /** 连接列表中任意一个设备成功回调(宿主是调用方) */
    connecting2AnyDeviceInTheList_Succeed_Callback(equipmentCode) {
      this.getUsingEuipments_WithHide((euipmentArr) => {
        if (!euipmentArr.length) return;
        const id = this.getIdByFeatures(
          euipmentArr,
          {
            equipmentId: equipmentCode,
          },
          "为《连接列表中任意一个设备》置顶对应设备"
        );
        if (id === -1) return;
        this.$store.commit("setIdOfConnectedDevice", id);
        this.stick({ id: id });
        this.$toast("operate successful");
      }, null);
    },
    /** 连接列表中任意一个设备失败回调(宿主是调用方) */
    connecting2AnyDeviceInTheList_Failed_Callback(equipmentCode) {
      this.$toast.clear();
      this.$toast("operate fail");
    },
    /** 更新电量 */
    updateBattery() {
      this.battery_CurDevice = this.theLatestBattery;
    },
    /** 从 array 中搜索出一个包含制定特征的元素的id */
    getIdByFeatures(array, features, clue) {
      const curArray = JSON.parse(JSON.stringify(array));
      let result = -1;

      for (let i = 0; i < curArray.length; i++) {
        const device = curArray[i];
        switch (typeof features) {
          case "object":
            for (const key in features) {
              if (
                Object.hasOwnProperty.call(device, key) &&
                device[key] === features[key]
              ) {
                result = device.id;
              }
            }
            break;

          default:
            if (device === features) result = device.id;
        }
        if (result !== -1) break;
      }

      let reminderMsg = "";
      switch (typeof features) {
        case "object":
          for (const key in features) {
            reminderMsg =
              reminderMsg +
              (reminderMsg.length > 0 ? " && " : "") +
              `${key}=${features[key]}`;
          }
          break;

        default:
          reminderMsg = features;
      }

      if (result === -1) {
        console.error(
          `没有找到[${reminderMsg}]的元素,无法获得id,导致无法${clue}.列表数据为:`
        );
        console.info(curArray);
      }

      return result;
    },
  },
};
</script>

<style lang="less">
.home {
  .container {
    overflow: hidden;
    padding: 24px 0;
  }
  .van-pull-refresh {
    overflow: inherit;
  }
  .pull {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px auto 30px;
    width: 56%;
    height: 60px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.2);
    font-size: 18px;
  }
  .card {
    padding: 0 24px 24px;
    .capsule {
      padding-right: 20px;
      background: #fff;
      border-radius: 15px;
      box-shadow: 0px 5px 13px 0px rgba(195, 13, 35, 0.1);
      font-size: 18px;
    }
    .card-item {
      background: #fff;
      padding: 25px 35px;
      border-radius: 15px;
      box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.2);
    }
    .van-swipe-cell {
      overflow: inherit;
      .swipe {
        box-sizing: border-box;
        height: 100%;
        padding-left: 30px;
        i {
          padding: 20px;
        }
      }
    }
    .left {
      width: 65%;
      .connect {
        font-size: 22px;
        .connect-point {
          display: block;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          margin-right: 9px;
        }
      }
      .title {
        font-size: 30px;
        padding: 25px 0 10px;
        font-weight: bold;
      }
      .desc {
        width: 100%;
        font-size: 22px;
        word-wrap: break-word;
        margin: 14px 0;
      }
      .step-container {
        margin: 20px 0 10px;
        .step-bg {
          position: relative;
          width: 56%;
          height: 20px;
          border-radius: 22px;
          background: #c1c1c1;
          overflow: hidden;
        }
        span {
          position: absolute;
          top: 0;
          left: 0;
          height: inherit;
          border-radius: 22px;
          background: linear-gradient(90deg, #3ee191, #24dedd);
        }
      }
    }
    .right {
      width: 32%;
      img {
        margin-top: 40px;
        width: 140px;
        height: 240px;
        object-fit: cover;
      }
    }
    .login-content {
      padding: 30px 63px;
      font-size: 22px;
      text-align: center;
      font-weight: bold;
      line-height: 1.5;
      .btn1,
      .btn2 {
        font-weight: normal;
        margin-top: 20px;
        width: 150px;
        height: 60px;
        line-height: 60px;
        color: #fff;
        border-radius: 16px;
      }
      .btn1 {
        background: #c1c1c1;
      }
      .btn2 {
        margin-left: 40px;
        background: linear-gradient(30deg, #3ee191, #24dedd);
      }
    }
  }
  .power {
    position: relative;
    width: 28px;
    height: 22px;
    span {
      position: absolute;
      top: 50%;
      left: 6px;
      transform: translateY(-50%);
      height: 60%;
    }
  }
}
</style>
